const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.company_roles_and_permissions/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.company_roles_and_permissions/LIST_COMPANY_ROLES_AND_PERMISSIONS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        ...action.response.pagination,
      };
    case 'table.company_roles_and_permissions/LIST_COMPANY_ROLES_AND_PERMISSIONS_FILTERS_SUCCESS':
      return {
        ...state,
        filters: action.response.filters,
      };
    default:
      return state;
  }
}
